(function () {
    'use strict';
    angular.module('app').controller('AssignJobSequencePriorityModalController', AssignJobSequencePriorityModalController);
    AssignJobSequencePriorityModalController.$inject = [
        'selectedJobs',
        '$uibModalInstance',
        'FleetService',
        'toastr'
    ];

    function AssignJobSequencePriorityModalController(
        selectedJobs,
        $uibModalInstance,
        FleetService,
        toastr
    ) {
        const vm = this;
        vm.closeModal = closeModal;
        vm.assign = assign;
        vm.isDuplicatePriority = isDuplicatePriority;

        init();

        function init() {
            vm.jobs = selectedJobs;
        }

        function assign(form) {
            if (form.$invalid) { 
                form.$setSubmitted();
                return; 
            }

            FleetService.Jobs.assingPriority(vm.jobs, data => {
                $uibModalInstance.close({isReload: true});
                toastr.message("Job priority successfully assigned.")
            }, error => {
                toastr.error(error.message, 'Error');
            });
        }

        function isDuplicatePriority(job) {
            if (job.priority) {
                const duplicate = vm.jobs.find(jobData => angular.getObjVal(jobData, 'priority') === job.priority && job.id !== jobData.id);
                if (duplicate) {
                    return 'Duplicate Priority';
                }
            }
            
            return null;
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
        
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/modal/AssignJobSequencePriorityModalController.js